<template>
  <div class="kye-report-fzkp003" @click="handleClick('cardClick')">
    <div class="fzkp003_main-cell-title">
      <img
        class="fzkp003_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
      <div
        class="fzkp003_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
          class="fzkp003_main-icon2"
          :icon="data.mainIcon2"
          :popover="data.popover"
          @click="handleClick('mainIcon2')">
          <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
    </div>
    <div class="fzkp003_main-cell-index">
      <div class="fzkp003_order-cell-index">
        <div class="fzkp003_main-index-cell" @click="handleClick('mainIndex')">
          <div
            class="fzkp003_main-index"
            v-events="{ eventsMap, args: ['mainIndex', data.mainIndex]}"
          >{{ data.mainIndex }}</div>
          <div
            class="fzkp003_main-index-unit"
            v-events="{ eventsMap, args: ['mainIndexUnit', data.mainIndexUnit]}"
          >{{ data.mainIndexUnit }}</div>
        </div>
        <div class="fzkp003_order-cell-title">
          <div
            class="fzkp003_order-title"
            @click="handleClick('orderTitle')"
            v-events="{ eventsMap, ignoreEventName, args: ['orderTitle', data.orderTitle]}"
          >{{ data.orderTitle }}</div>
          <div class="fzkp003_order-icon-cell" :class="getIndexColor(data.orderIcon)">
            <div
              class="fzkp003_order-index"
              @click="handleClick('orderIndex')"
              v-events="{ eventsMap, ignoreEventName, args: ['orderIndex', data.orderIndex]}"
            >{{ data.orderIndex }}</div>
            <kyeReportCardArrow
              @click="handleClick('orderIcon')"
              class="fzkp003_order-icon"
              :type="data.orderIcon"
              v-events="{ eventsMap, ignoreEventName, args: ['orderIcon', data.orderIcon]}"
            ></kyeReportCardArrow>
          </div>
        </div>
      </div>
      <div class="fzkp003_list-cell">
        <div
          class="fzkp003_list-index-cell"
          :class="[`fzkp003_list-index-cell-${listIndex}`]"
          v-for="(listItem, listIndex) in data.list"
          :key="listIndex">
          <div class="fzkp003_list-cell-index">
            <div class="fzkp003_list-cell-index-left">
              <div
                class="fzkp003_list-title"
                @click="handleClick('listTitle', listIndex)"
                v-events="{ eventsMap, ignoreEventName, args: ['listTitle', listIndex, listItem.listTitle]}"
              >{{ listItem.listTitle }}</div>
              <div
                class="fzkp003_list-index1"
                @click="handleClick('listIndex1', listIndex)"
                v-events="{ eventsMap, ignoreEventName, args: ['listIndex1', listIndex, listItem.listIndex1]}"
              >{{ listItem.listIndex1 }}</div>
            </div>
            <div
              class="fzkp003_list-index2"
              @click="handleClick('listIndex2', listIndex)"
              v-events="{ eventsMap, ignoreEventName, args: ['listIndex2', listIndex, listItem.listIndex2]}"
            >{{ listItem.listIndex2 }}</div>
          </div>
          <el-progress
            class="fzkp003_list-rate"
            :show-text="false"
            :color="listItem.listRateColor"
            :percentage="listItem.listRate"
            @click="handleClick('listRate', listIndex)"
            v-events="{ eventsMap, ignoreEventName, args: ['listRate', listIndex, listItem.listRate]}"
          ></el-progress>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/fzkp003.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportFzkp003',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-fzkp003 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  padding: 12px 16px;
  box-shadow: 0px 2px 6px 0px rgba(211, 211, 211, 0.5);
  background: linear-gradient(180deg, #FFFAF2 1%, #FFFFFE 56%, #FFFFFF 100%);
  .fzkp003_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #333333;
    font-size: 12px;
    .fzkp003_main-icon1 {
      width: 12px;
      height: 12px;
    }
    .fzkp003_main-title {
      margin-left: 8px;
    }
    .fzkp003_main-icon2 {
      margin-left: 4px;
    }
  }
  .fzkp003_main-cell-index {
    display: flex;
    flex-direction: row;
    margin-top: 16px;
    .fzkp003_order-cell-index {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      padding: 10px 0;
      .fzkp003_main-index-cell {
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-direction: row;
        color: #999999;
        color: var(--g-color-primary);
        .fzkp003_main-index {
          font-size: 20px;
          line-height: 24px;
          font-weight: 600;
        }
        .fzkp003_main-index-unit {
          font-size: 12px;
          line-height: 12px;
          display: flex;
          flex-direction: column-reverse;
        }
      }
      .fzkp003_order-cell-title {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 16px;
        gap: 8px;
        color: #666666;
        .fzkp003_order-icon-cell {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }
    .fzkp003_list-cell {
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
      justify-content: space-around;
      .fzkp003_list-index-cell {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        .fzkp003_list-cell-index {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          width: 100%;
          .fzkp003_list-cell-index-left {
            display: flex;
            flex-direction: row;
            .fzkp003_list-title {
              color: #666666;
            }
            .fzkp003_list-index1 {
              color: #333333;
              margin-left: 10px;
            }
          }
        }
        .fzkp003_list-rate {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .fzkp003_list-index {
          font-size: 12px;
          color: #333333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp003/index.vue